<template>
  <jz-container class="learning-history-achievement">
    <jz-container class="icon">
      <jz-icon v-if="item.trophy" :src="icons.trophies[item.trophy]" />

      <jz-icon v-if="item.type" :src="icons.badges[item.type]" />
    </jz-container>

    <jz-container class="total">{{ item.total }}</jz-container>

    <jz-container class="empty-message" v-if="item.total <= 0">
      <span class="badge" v-if="emptyBadge">{{ emptyBadge }}</span>
      <span class="text">{{ emptyText | __ }}</span>
    </jz-container>

    <jz-container v-for="(exercise, index) in item.details" :key="index" class="exercise-details">
      <span class="label">
        {{ `exercise.function.${exercise.exerciseType}` | __ }}
        {{ `exercise.type.${exercise.exerciseType}` | __ }}
      </span>

      <span class="content">{{ exercise.count }}</span>
    </jz-container>
  </jz-container>
</template>

<script>
import Vue from "vue";

import iconBronzeAchievement from "@joyz/app-core/assets/trophy/achievements/Bronze.svg";
import iconGoldAchievement from "@joyz/app-core/assets/trophy/achievements/Gold.svg";
import iconListeningBadge from "@joyz/app-core/assets/badge/Listening.svg";
import iconMicrophone from "@joyz/app-core/assets/icons/default/Microphone.svg";
import iconPronunciationBadge from "@joyz/app-core/assets/badge/Pronunciation.svg";
import iconSilverAchievement from "@joyz/app-core/assets/trophy/achievements/Silver.svg";
import iconWordBadge from "@joyz/app-core/assets/badge/Word.svg";

export default Vue.extend({
  name: "LearningHistoryAchievement",
  props: {
    item: { type: Object, required: true }
  },
  data() {
    return {
      icons: {
        badges: {
          1: iconWordBadge,
          2: iconListeningBadge,
          3: iconPronunciationBadge
        },
        microphone: iconMicrophone,
        trophies: {
          1: iconBronzeAchievement,
          2: iconSilverAchievement,
          3: iconGoldAchievement
        }
      }
    };
  },
  computed: {
    emptyBadge() {
      if (this.item.trophy) {
        return "";
      }
      return "learned";
    },
    emptyText() {
      if (this.item.trophy) {
        return "learning-history.empty-message.trophy";
      } else if (this.item.type) {
        return "learning-history.empty-message.badge";
      }
      return "";
    }
  }
});
</script>

<style lang="scss">
.learning-history-achievement {
  padding: $gutter;
  text-align: center;

  .icon {
    img {
      height: 72px;
    }
  }

  .total {
    color: var(--color-dark);
    font-size: $font-size-xxl;
    font-weight: bold;
    height: 38px;
  }

  .empty-message {
    .badge {
      background-color: var(--color-secondary-tertiary-background-light);
      border-radius: 4px;
      color: var(--color-dark);
      display: inline-block;
      font-size: 0.625rem;
      font-weight: bold;
      margin: 0 4px;
      padding: 4px;
      text-transform: uppercase;
      white-space: nowrap;
    }

    .text {
      color: var(--color-secondary);
      font-size: $font-size-sm;
      font-weight: bold;
    }
  }

  .exercise-details {
    width: 160px;
    max-width: 160px;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
  }

  .label {
    color: var(--color-secondary);
    font-size: $font-size-sm;
    font-weight: bold;
  }

  .content {
    color: var(--color-secondary);
    font-size: $font-size-sm;
    font-weight: bold;
  }
}
</style>
